<template>
  <div id="list" >
    <div class="name" >教练员名单</div>
    <div class="href" >添加球员</div>
    <div class="title" >
      <ul>
        <li>账户</li>
        <li>姓名</li>
        <li>性别</li>
      </ul>
    </div>
    <div class="main" >
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getPlayerList">
        <van-cell v-for="item in list" :key="item.id">
          <div class="data-list" >
            <ul>
              <li>{{item.mobile}}</li>
              <li>{{item.trueName}}</li>
              <li>{{item.gender}}</li>
            </ul>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { getCoachList } from '@/api/user'
import { List } from 'vant'
Vue.use(List)
export default {
  name: 'CoachList',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      organizationId: null,
      pageNum: 1
    }
  },
  mounted() {
    this.organizationId = this.$route.query.id || 4
  },
  methods: {
    getPlayerList() {
      let params = {
        organizationId: this.organizationId,
        pageSize: 10,
        pageNum: this.pageNum
      }
      getCoachList(params).then((resolve) => {
        this.loading = false
        this.finished = true
        this.list = this.list.concat(resolve.data.list)
        if (!resolve.data.list || resolve.data.list.length < 10) {
        } else {
          this.pageNum++
        }
      }, (reject) => {})
    }
  },
  computed: {}
}
</script>
<style>
  #list {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
  }

  #list .name {
    font-size: 22px;
    text-align: center;
    font-weight: bolder;
    padding: 15px 0;
  }

  #list .title {
    padding: 15px 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  #list .title ul {
    display: flex;
  }

  #list .title ul li {
    flex: 1;
    text-align: center;
    font-size: 16px;
    border-right: 1px solid #ccc;
  }

  #list .title ul li:last-child {
    border-right: none;
  }

  #list .main {
    position: absolute;
    width: 100%;
    height: calc(100% - 100px);
  }

  #list .href {
    text-align: right;
    padding: 0 0 10px 0;
  }

  #list .van-cell:not(:last-child)::after {
    left: 15px;
    right: 15px;
  }

  #list .data-list ul {
    display: flex;
  }

  #list .data-list ul li {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/coach-list.vue